// Slide model based on API::V1::TriggeredSlideActivityResultSerializer
export default {

  // Relationships
  activity: {
    jsonApi: 'hasOne',
    type: 'activities'
  },

  slide: {
    jsonApi: 'hasOne',
    type: 'triggered_slides'
  },

  user: {
    jsonApi: 'hasOne',
    type: 'user'
  },

  // Attributes
  status: null,
  event: null,
  results: {},
  updated_at: null
}
